<template>
    <div>
        <v-container>
            <v-card class="soli-round mb-5 stripe-shadow" outlined>
                <v-card-subtitle class="pb-0 justify-start flex"
                    >Amount Due</v-card-subtitle
                >
                <v-card-title class="pt-0" v-if="amountDue">
                    {{ formatUnitAmount(amountDue) }}
                </v-card-title>
                <v-skeleton-loader
                    v-else
                    class="short-bone"
                    max-width="200"
                    type="list-item"
                ></v-skeleton-loader>
            </v-card>
            <!-- Display a payment form -->
            <form id="payment-form">
                <div id="payment-element">
                    <!-- Elements will create form elements here -->
                </div>
                <div id="error-message">
                    <!-- Display error message to your customers here -->
                </div>
            </form>

            <v-card-text class="pb-0 mt-4">
                This will schedule an assessment lesson with
                <a>{{ teacherName }}</a> risk free with our
                <a
                    href="https://musicologielessons.com/why-choose-musicologie"
                    target="_blank"
                    >Perfect Match Promise</a
                >
                Your card will be charged
                {{ amountDue ? formatUnitAmount(amountDue) : "..." }}. You'll
                receive a welcome email at <a>{{ email }}</a> with further
                instructions.
            </v-card-text>
        </v-container>
        <p v-if="errors" class="caption red--text mx-auto">
            {{ Object.values(errors)[0] }}
        </p>
        <v-container class="pb-0">
            <SoliBtn
                v-if="showSubmit"
                :gradient="valid ? 'gradient-orange' : null"
                text="Book It!"
                icon="music_note"
                block
                :disabled="!valid"
                @click="submitManualCard()"
                :loading="loading"
            ></SoliBtn
        ></v-container>
    </div>
</template>

<script>
export default {
    props: {
        errors: {},
        email: {},
        location_id: {},
        teacherName: {},
        lessonType: {},
        showSubmit: {
            type: Boolean,
            default: false,
        },
        valid: false,
    },
    data() {
        return {
            paid: false,
            elementsLoading: false,
            stripe: null,
            stripeElements: null,
            loading: false,
            amountDue: null,
            priceId: null,
        };
    },
    methods: {
        manualCardElement() {
            this.elementsLoading = true;

            const response = axios
                .get(route("stripe.guestPayment"), {
                    params: {
                        email: this.email,
                        location_id: this.location_id,
                    },
                })
                .then((resp) => {
                    const clientSecret = resp.data.client_secret;
                    this.stripe = Stripe(resp.data.stripe_key);
                    this.amountDue = resp.data.amountDue;
                    this.priceId = resp.data.priceId;
                    const appearance = {
                        theme: "stripe",
                        labels: "floating",
                        variables: {
                            colorText: "#4b6876",
                            spacingUnit: "2px",
                            borderRadius: "12px",
                            spacingTab: "16px",
                            spacingGridRow: "16px",
                            spacingGridColumn: "16px",
                            // See all possible variables below
                        },
                    };
                    const elements = this.stripe.elements({
                        clientSecret,
                        appearance,
                    });
                    this.stripeElements = elements;

                    const paymentElement = elements.create("payment", {
                        wallets: { applePay: "never", googlePay: "never" },
                        terms: { card: "never" },
                    });
                    paymentElement.mount("#payment-element");
                    paymentElement.on("ready", (event) => {
                        this.elementsLoading = false;
                        this.paid = true;
                    });
                });
        },
        submitManualCard() {
            this.$emit("paymentLoading", true);
            this.loading = true;
            const elements = this.stripeElements;
            this.stripe
                .confirmSetup({
                    elements,
                    confirmParams: {
                        return_url: route("getStarted.create"),
                    },
                    redirect: "if_required",
                })
                .then((resp) => {
                    if (resp.error) {
                        console.log(resp);
                        this.loading = false;
                        this.$emit("paymentLoading", false);
                    } else {
                        this.loading = false;
                        this.$emit("paymentLoading", false);
                        this.$emit("submit", {
                            payment: resp.setupIntent,
                            priceId: this.priceId,
                        });
                    }
                });
        },
    },
    mounted() {
        this.manualCardElement();
    },
    created() {
        this.$loadScript("https://js.stripe.com/v3/");
    },
};
</script>

<style>
.short-bone {
    transform: translateY(-6px);
}
</style>
